(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/home-dialogs.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/home-dialogs.js');
"use strict";


const showHomeLocationError = () => {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title: 'Tyvärr kan vi inte hitta din hemadress',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kan alltid leta upp din hemadress på kartan. Eller om du befinner dig hemma så kan du spela på din position.'
    }],
    actions: [{
      title: 'Jag förstår'
    }]
  }));
};
const selfServiceCantShowHomeLocDialog = _ref => {
  let {
    price,
    firstDraw,
    lastDraw
  } = _ref;
  return new Promise(resolve => {
    const [firstOneWeekDraw, ...rest] = svs.lyckoplatsen.shared_draws.data.allDraws.sort((a, b) => new Date(a.regCloseTime) - new Date(b.regCloseTime)).slice(0, 3);
    const lastOneWeekDraw = rest[rest.length - 1];
    const drawText = svs.tur.pay_lyckoplatsen.drawStartEndText({
      startDate: firstDraw,
      endDate: lastDraw
    });
    const drawTextOneWeek = svs.tur.pay_lyckoplatsen.drawStartEndText({
      startDate: firstOneWeekDraw,
      endDate: lastOneWeekDraw,
      weeks: 1
    });
    let dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'simplicity',
      title: 'Din lyckoplats är din hemadress',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Vi kan inte visa din folkbokföringsadress på kartan men du kan lägga spelet i varukorgen och betala i kassan.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: "".concat(drawText.totalText, " <br /> ").concat(drawText.startEndText)
      }],
      actions: [{
        title: 'Avbryt',
        callback: () => {
          dialog.close();
          resolve(false);
        }
      }, {
        title: "L\xE4gg i varukorgen (".concat(price, "kr)"),
        callback: () => {
          dialog.close();
          resolve(true);
        }
      }]
    });
    const OneWeekCampaignDialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'simplicity',
      title: 'Din lyckoplats är din hemadress',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Vi kan inte visa din folkbokföringsadress på kartan men du kan lägga spelet i varukorgen och betala i kassan.',
        align: svs.ui.dialog.message.align.CENTER
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: "".concat(drawText.totalText, " <br /> ").concat(drawText.startEndText, " Pris 160 kr."),
        align: svs.ui.dialog.message.align.CENTER
      }, {
        type: svs.ui.dialog.message.CHECKBOX,
        text: "<b>KAMPANJ</b>! Prova en vecka, 3 dragningar. <br />".concat(drawTextOneWeek.startEndText, " Pris 40 kr."),
        align: svs.ui.dialog.message.align.CENTER,
        value: true
      }],
      actions: [{
        title: 'Avbryt',
        callback: () => {
          OneWeekCampaignDialog.close();
          resolve(false);
        }
      }, {
        title: 'Lägg i varukorgen',
        callback: (e, forms) => {
          var _forms$;
          const campaignChecked = (forms === null || forms === void 0 || (_forms$ = forms[0]) === null || _forms$ === void 0 ? void 0 : _forms$.checked) === true;
          const weeks = campaignChecked ? 1 : svs.lyckoplatsen.components.shared_constants.CONSTANTS.DRAWS.NUMBER_OF_WEEKS;
          OneWeekCampaignDialog.close();
          resolve({
            weeks
          });
        }
      }]
    });
    if (svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w')) {
      dialog = OneWeekCampaignDialog;
    }
    svs.ui.dialog.api.add(dialog);
  });
};
const askPremisionToUseHomeLocation = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'help-2',
    title: 'Spela hemma',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'För att spela på din hemadress behöver vi veta var du bor. Logga in eller skapa en inloggning med BankID eller Freja så fixar vi detta direkt.'
    }],
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Logga in',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  showHomeLocationError,
  askPremisionToUseHomeLocation,
  selfServiceCantShowHomeLocDialog
});

 })(window);